<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('administration.employee.employeeProfile.employeeProfile') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('administration.employee.employeeProfile.employeeProfile'),
            href: '/employees'
          },
          {
            text: $t('administration.employee.employeeProfile.edit'),
            active: true
          }
        ]"
      />
    </div>
    <ts-loading-banner :loading="ready_fetch">
      <div class="row">
        <div class="col-lg-3 col-md-5 col-sm-12">
          <ts-card>
            <ts-card-wrapper>
              <div class="d-flex flex-column align-items-center">
                <ts-image-input
                  class="employee-image-input"
                  :file="model.photo ? model.photo : file"
                  @input="file => (model.photo = file)"
                  :width="175"
                  :height="225"
                  crop
                ></ts-image-input>
                <span
                  ><i>{{
                    $t('administration.employee.employeeProfile.employeePhoto')
                  }}</i></span
                >
                <div class="validate">
                  {{ errors.first('photo') }}
                </div>
              </div>
              <div class="form-group">
                <label
                  >{{ $t('administration.employee.employeeProfile.nameKh') }}
                </label>
                <input
                  ref="name_kh"
                  type="text"
                  v-model.trim="model.name_kh"
                  class="form-control kh-font"
                  :class="{ 'is-invalid': errors.has('name_kh') }"
                />
                <div class="invalid-feedback" v-if="errors.has('name_kh')">
                  {{ errors.first('name_kh') }}
                </div>
              </div>
              <div class="form-group required">
                <label class="required">{{
                  $t('administration.employee.employeeProfile.nameEn')
                }}</label>
                <input
                  type="text"
                  v-model.trim="model.name_en"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('name_en') }"
                />
                <div class="invalid-feedback" v-if="errors.has('name_en')">
                  {{ errors.first('name_en') }}
                </div>
              </div>
              <div class="form-group">
                <label
                  >{{ $t('administration.employee.employeeProfile.gender') }}
                </label>
                <select class="form-control" v-model.number="model.gender">
                  <option
                    v-if="model.gender === null"
                    :value="null"
                    disabled
                    selected
                    style="display: none;"
                  >
                    {{ $t('select') }}
                  </option>
                  <option
                    v-else
                    value=""
                    disabled
                    selected
                    style="display: none;"
                  >
                    {{ $t('select') }}
                  </option>
                  <option
                    v-for="(gender, index) in genders"
                    :key="index"
                    :value="gender.value"
                    >{{ gender.description }}
                  </option>
                </select>
                <div class="invalid-feedback" v-if="errors.has('gender')">
                  {{ errors.first('gender') }}
                </div>
              </div>
              <div class="form-group">
                <label
                  >{{
                    $t('administration.employee.employeeProfile.dateOfBirth')
                  }}
                </label>
                <ts-date-picker-input v-model="model.date_of_birth" />
                <div class="validate">
                  {{ errors.first('date_of_birth') }}
                </div>
              </div>
              <div class="form-group">
                <label>
                  {{
                    $t('administration.employee.employeeProfile.maritalStatus')
                  }}</label
                >
                <select
                  class="form-control"
                  id="marital_status"
                  v-model.number="model.marital_status"
                >
                  <option
                    v-if="model.marital_status === null"
                    :value="null"
                    disabled
                    selected
                    style="display: none;"
                  >
                    {{ $t('select') }}
                  </option>
                  <option
                    v-else
                    value=""
                    disabled
                    selected
                    style="display: none;"
                  >
                    {{ $t('select') }}
                  </option>
                  <option
                    v-for="(marital_status, index) in marital_statuses"
                    :key="index"
                    :value="marital_status.value"
                  >
                    {{ marital_status.description }}
                  </option>
                </select>
                <div class="invalid-feedback" v-if="errors.has('name_en')">
                  {{ errors.first('name_en') }}
                </div>
              </div>
            </ts-card-wrapper>
          </ts-card>
          <br />
          <ts-card>
            <ts-card-wrapper>
              <h1 class="section-divider">
                {{ $t('administration.employee.employeeProfile.notification') }}
              </h1>
              <br />
              <div class="form-group">
                <label
                  >{{
                    $t(
                      'administration.employee.employeeProfile.notificationReceiver'
                    )
                  }}
                </label>
                <select
                  class="form-control"
                  v-model="model.notification_receiver"
                  multiple
                >
                  <option
                    v-for="(employee, index) in employees"
                    :key="index"
                    :value="employee.staff_id"
                    >{{ employee.name_en }}
                  </option>
                </select>
                <div class="invalid-feedback" v-if="errors.has('name_en')">
                  {{ errors.first('name_en') }}
                </div>
              </div>
              <div class="form-group">
                <ts-checkbox v-model="model.mobile_notification">{{
                  $t(
                    'administration.employee.employeeProfile.mobileNotification'
                  )
                }}</ts-checkbox>
              </div>
              <div class="form-group">
                <ts-checkbox v-model="model.email_notification">{{
                  $t(
                    'administration.employee.employeeProfile.emailNotification'
                  )
                }}</ts-checkbox>
              </div>
              <div class="form-group">
                <ts-checkbox
                  v-model="model.is_receive_abd_parent_comment_notification"
                  >{{
                    $t(
                      'administration.employee.employeeProfile.allAboutMyDayNotification'
                    )
                  }}</ts-checkbox
                >
              </div>
              <div class="form-group">
                <ts-checkbox v-model="model.is_receive_next_payment_alert">{{
                  $t(
                    'administration.employee.employeeProfile.receiveNextPaymentAlert'
                  )
                }}</ts-checkbox>
              </div>
            </ts-card-wrapper>
          </ts-card>
        </div>
        <div class="col-lg-9 col-md-7 col-sm-12">
          <ts-card>
            <ts-card-wrapper>
              <form class="form-horizontal">
                <h1 class="section-divider">
                  {{ $t('administration.employee.employeeProfile.employment') }}
                </h1>
                <div class="row mb-3">
                  <div class="col-sm-12 col-lg-6 col-md-12">
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right required"
                      >
                        {{
                          $t(
                            'administration.employee.employeeProfile.hiringDate'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        <ts-date-picker-input
                          v-model="model.hired_date"
                          @input="getImployeeId()"
                        />
                        <div class="validate">
                          {{ errors.first('hired_date') }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right required"
                      >
                        {{
                          $t(
                            'administration.employee.employeeProfile.employeeID'
                          )
                        }}</label
                      >
                      <div class="col-md-7">
                        <input
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('emp_id') }"
                          v-model.number="model.emp_id"
                          ref="emp_id"
                          readonly
                        />
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('emp_id')"
                        >
                          {{ errors.first('emp_id') }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t('administration.employee.employeeProfile.division')
                        }}
                      </label>
                      <div class="col-md-7">
                        <select
                          v-model.number="model.division_id"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('division_id') }"
                          @change="getDepartment(model.division_id)"
                        >
                          <option
                            v-if="model.division_id === null"
                            :value="null"
                            disabled
                            selected
                            style="display: none;"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-else
                            value=""
                            disabled
                            selected
                            style="display: none;"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-for="(division, index) in divisions"
                            :key="index"
                            :value="division.division_id"
                          >
                            {{ division.division_name_en }}
                          </option>
                        </select>
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('division_id')"
                        >
                          {{ errors.first('division_id') }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t(
                            'administration.employee.employeeProfile.department'
                          )
                        }}
                        <i
                          v-if="
                            departments.length == 0 && model.division_id !== ''
                          "
                          class="fas fa-spinner fa-pulse label-loading"
                        ></i>
                      </label>
                      <div class="col-md-7">
                        <select
                          v-model.number="model.department_id"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('department_id') }"
                        >
                          <option
                            v-if="model.department_id === null"
                            :value="null"
                            disabled
                            selected
                            style="display: none;"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-else
                            value=""
                            disabled
                            selected
                            style="display: none;"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-for="(department, index) in departments"
                            :key="index"
                            :value="department.department_id"
                          >
                            {{ department.department_name_en }}
                          </option>
                        </select>
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('department_id')"
                        >
                          {{ errors.first('department_id') }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-lg-6 col-md-12">
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right required"
                      >
                        {{
                          $t('administration.employee.employeeProfile.position')
                        }}</label
                      >
                      <div class="col-md-7">
                        <select
                          v-model.number="model.position_id"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('position_id') }"
                        >
                          <option
                            v-if="model.position_id === null"
                            :value="null"
                            disabled
                            selected
                            style="display: none;"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-else
                            value=""
                            disabled
                            selected
                            style="display: none;"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-for="(position, index) in positions"
                            :key="index"
                            :value="position.position_id"
                          >
                            {{ position.pos_name_en }}
                          </option>
                        </select>
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('position_id')"
                        >
                          {{ errors.first('position_id') }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right required"
                      >
                        {{
                          $t('administration.employee.employeeProfile.status')
                        }}
                      </label>
                      <div class="col-md-7">
                        <select
                          class="form-control"
                          id="status"
                          v-model="model.status"
                        >
                          <option v-for="status in statuses" :value="status">{{
                            status
                          }}</option>
                        </select>
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('status')"
                        >
                          {{ errors.first('status') }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t(
                            'administration.employee.employeeProfile.statusEffectiveDate'
                          )
                        }}

                        <span v-if="required" class="text-danger">*</span>
                      </label>
                      <div class="col-md-7">
                        <ts-date-picker-input
                          ref="status_effective_date"
                          v-model="model.status_effective_date"
                          :disabled="!required"
                        />
                        <div class="validate">
                          {{ errors.first('status_effective_date') }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t('administration.employee.employeeProfile.shift')
                        }}
                      </label>
                      <div class="col-md-7">
                        <select
                          v-model.number="model.shift_id"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('shift_id') }"
                        >
                          <option
                            v-if="model.shift_id === null"
                            :value="null"
                            disabled
                            selected
                            style="display: none;"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-else
                            value=""
                            disabled
                            selected
                            style="display: none;"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-for="(shift, index) in shifts"
                            :key="index"
                            :value="shift.shift_id"
                          >
                            {{ shift.shift_name }} ({{ shift.shift_type }})
                          </option>
                        </select>
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('shift_id')"
                        >
                          {{ errors.first('shift_id') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <h1 class="section-divider">
                  {{
                    $t('administration.employee.employeeProfile.addressContact')
                  }}
                </h1>
                <div class="row mb-3">
                  <div class="col-sm-12 col-lg-6 col-md-12">
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t('administration.employee.employeeProfile.province')
                        }}
                      </label>
                      <div class="col-md-7">
                        <select
                          v-model.number="model.province_code"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('province_code') }"
                          @change="getDistrict(model.province_code)"
                        >
                          <option
                            v-if="model.province_code === null"
                            :value="null"
                            disabled
                            selected
                            style="display: none;"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-else
                            value=""
                            disabled
                            selected
                            style="display: none;"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-for="(province, index) in provinces"
                            :key="index"
                            :value="province.province_code"
                          >
                            {{ province.province_name }}
                          </option>
                        </select>
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('province_code')"
                        >
                          {{ errors.first('province_code') }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t('administration.employee.employeeProfile.district')
                        }}
                        <i
                          v-if="
                            districts.length == 0 && model.province_code !== ''
                          "
                          class="fas fa-spinner fa-pulse label-loading"
                        ></i>
                      </label>
                      <div class="col-md-7">
                        <select
                          :readonly="districts.length == 0"
                          v-model.number="model.district_code"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('district_code') }"
                          @change="getCommune(model.district_code)"
                        >
                          <option
                            v-if="model.district_code === null"
                            :value="null"
                            disabled
                            selected
                            style="display: none;"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-else
                            value=""
                            disabled
                            selected
                            style="display: none;"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-for="(district, index) in districts"
                            :key="index"
                            :value="district.district_code"
                          >
                            {{ district.district_name }}
                          </option>
                        </select>
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('district_code')"
                        >
                          {{ errors.first('district_code') }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t('administration.employee.employeeProfile.commune')
                        }}
                        <i
                          v-if="
                            communes.length == 0 && model.district_code !== ''
                          "
                          class="fas fa-spinner fa-pulse label-loading"
                        ></i>
                      </label>
                      <div class="col-md-7">
                        <select
                          :readonly="communes.length == 0"
                          v-model.number="model.commune_code"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('commune_code') }"
                          @change="getVillage(model.commune_code)"
                        >
                          <option
                            v-if="model.commune_code === null"
                            :value="null"
                            disabled
                            selected
                            style="display: none;"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-else
                            value=""
                            disabled
                            selected
                            style="display: none;"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-for="(commune, index) in communes"
                            :key="index"
                            :value="commune.commune_code"
                          >
                            {{ commune.commune_name }}
                          </option>
                        </select>
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('commune_code')"
                        >
                          {{ errors.first('commune_code') }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t('administration.employee.employeeProfile.village')
                        }}
                        <i
                          v-if="
                            villages.length == 0 && model.commune_code !== ''
                          "
                          class="fas fa-spinner fa-pulse label-loading"
                        ></i>
                      </label>
                      <div class="col-md-7">
                        <select
                          :readonly="villages.length == 0"
                          v-model.number="model.village_code"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('village_code') }"
                        >
                          <option
                            v-if="model.village_code === null"
                            :value="null"
                            disabled
                            selected
                            style="display: none;"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-else
                            value=""
                            disabled
                            selected
                            style="display: none;"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-for="(village, index) in villages"
                            :key="index"
                            :value="village.village_code"
                          >
                            {{ village.village_name }}
                          </option>
                        </select>
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('village_code')"
                        >
                          {{ errors.first('village_code') }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-lg-6 col-md-12">
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right required"
                      >
                        {{
                          $t(
                            'administration.employee.employeeProfile.phoneLine1'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        <input
                          type="text"
                          v-model.trim="model.phone_number_1"
                          class="form-control"
                          :class="{
                            'is-invalid': errors.has('phone_number_1')
                          }"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('phone_number_1')"
                        >
                          {{ errors.first('phone_number_1') }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t(
                            'administration.employee.employeeProfile.phoneLine2'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        <input
                          type="text"
                          v-model.trim="model.phone_number_2"
                          class="form-control"
                          :class="{
                            'is-invalid': errors.has('phone_number_2')
                          }"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('phone_number_2')"
                        >
                          {{ errors.first('phone_number_2') }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t('administration.employee.employeeProfile.email')
                        }}
                      </label>
                      <div class="col-md-7">
                        <input
                          type="text"
                          v-model.trim="model.email"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('email') }"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('email')"
                        >
                          {{ errors.first('email') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <h1 class="section-divider">
                  {{ $t('administration.employee.employeeProfile.idCard') }}
                </h1>
                <div class="row mb-3">
                  <div class="col-sm-12 col-lg-6 col-md-12">
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{ $t('employee.idType') }}
                      </label>
                      <div class="col-md-7">
                        <select
                          v-model.number="model.id_type"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('id_type') }"
                        >
                          <option
                            v-if="model.id_type === null"
                            :value="null"
                            disabled
                            selected
                            style="display: none;"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-else
                            value=""
                            disabled
                            selected
                            style="display: none;"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-for="(id_type, index) in id_types"
                            :key="index"
                            :value="id_type.id_type"
                          >
                            {{ id_type.id_type_name }}
                          </option>
                        </select>
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('id_type')"
                        >
                          {{ errors.first('id_type') }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t('administration.employee.employeeProfile.idNumber')
                        }}
                      </label>
                      <div class="col-md-7">
                        <input
                          type="text"
                          v-model="model.id_number"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('id_number') }"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('id_number')"
                        >
                          {{ errors.first('id_number') }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-lg-6 col-md-12">
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t(
                            'administration.employee.employeeProfile.expiryDate'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        <ts-date-picker-input v-model="model.id_expiry_date" />
                        <div class="validate">
                          {{ errors.first('id_expiry_date') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <h1 class="section-divider">
                  {{
                    $t('administration.employee.employeeProfile.drivingLicense')
                  }}
                </h1>
                <div class="row mb-3">
                  <div class="col-sm-12 col-lg-6 col-md-12">
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t(
                            'administration.employee.employeeProfile.drivingLicenseNo'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        <input
                          type="text"
                          v-model.trim="model.driving_license_no"
                          class="form-control"
                          :class="{
                            'is-invalid': errors.has('driving_license_no')
                          }"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('driving_license_no')"
                        >
                          {{ errors.first('driving_license_no') }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-lg-6 col-md-12">
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t(
                            'administration.employee.employeeProfile.drivingIssueDate'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        <ts-date-picker-input
                          v-model="model.driving_issue_date"
                        />
                        <div class="validate">
                          {{ errors.first('driving_issue_date') }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t(
                            'administration.employee.employeeProfile.drivingExpiringDate'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        <ts-date-picker-input
                          v-model="model.driving_expiry_date"
                        />
                        <div class="validate">
                          {{ errors.first('driving_expiry_date') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <h1 class="section-divider">
                  {{ $t('administration.employee.employeeProfile.family') }}
                </h1>
                <div class="row mb-3">
                  <div class="col-sm-12 col-lg-6 col-md-12">
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t(
                            'administration.employee.employeeProfile.spouseName'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        <input
                          type="text"
                          v-model.trim="model.spouse_name"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('spouse_name') }"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('spouse_name')"
                        >
                          {{ errors.first('spouse_name') }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t(
                            'administration.employee.employeeProfile.spouseOccupation'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        <select
                          v-model.number="model.spouse_occupation_id"
                          class="form-control"
                          :class="{
                            'is-invalid': errors.has('spouse_occupation_id')
                          }"
                        >
                          <option
                            v-if="model.spouse_occupation_id === null"
                            :value="null"
                            disabled
                            selected
                            style="display: none;"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-else
                            value=""
                            disabled
                            selected
                            style="display: none;"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-for="(spouse_occupation,
                            index) in spouse_occupations"
                            :key="index"
                            :value="spouse_occupation.occupation_id"
                          >
                            {{ spouse_occupation.occupation_name }}
                          </option>
                        </select>
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('spouse_occupation_id')"
                        >
                          {{ errors.first('spouse_occupation_id') }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-lg-6 col-md-12">
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t('administration.employee.employeeProfile.children')
                        }}
                      </label>
                      <div class="col-md-7">
                        <input
                          type="number"
                          v-model.number="model.number_of_children"
                          class="form-control"
                          :class="{
                            'is-invalid': errors.has('number_of_children')
                          }"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('number_of_children')"
                        >
                          {{ errors.first('number_of_children') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col-sm-12 col-lg-12 col-md-12 text-right">
                    <ts-button
                      color="primary"
                      :waiting="waiting"
                      @click.prevent="update"
                    >
                      {{ $t('update') }}
                    </ts-button>
                    <ts-button
                      class="ml-2"
                      @click.prevent="$router.push({ name: 'employee' })"
                      >{{ $t('cancel') }}</ts-button
                    >
                  </div>
                </div>
              </form>
            </ts-card-wrapper>
          </ts-card>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import Compressor from 'compressorjs'
export default {
  name: 'employee-edit',
  data() {
    return {
      model: {
        emp_id: '',
        name_kh: '',
        name_en: '',
        position_id: '',
        hired_date: '',
        gender: '',
        date_of_birth: '',
        marital_status: '',
        id_type: '',
        id_number: '',
        id_expiry_date: '',
        phone_number_1: '',
        phone_number_2: '',
        email: '',
        driving_license_no: '',
        driving_issue_date: '',
        driving_expiry_date: '',
        status: 'Active',
        status_effective_date: '',
        province_code: '',
        district_code: '',
        commune_code: '',
        village_code: '',
        spouse_name: '',
        spouse_occupation_id: '',
        number_of_children: '',
        division_id: '',
        department_id: '',
        shift_id: '',
        notification_receiver: [],
        mobile_notification: false,
        email_notification: false,
        is_receive_abd_parent_comment_notification: false,
        is_receive_next_payment_alert: false,
        photo: null
      },
      errors: new Errors(),
      waiting: false,
      file: require('../../assets/user_default.png'),
      required: false,
      marital_statuses: [
        {
          value: 1,
          description: 'Single'
        },
        {
          value: 2,
          description: 'Married'
        }
      ],
      genders: [
        {
          value: 1,
          description: 'Male'
        },
        {
          value: 2,
          description: 'Female'
        }
      ]
    }
  },
  mounted() {
    this.$refs.name_kh.focus()
  },
  created() {
    this.fetchResourceBeforeCreate()
  },
  computed: {
    ...mapState('employee', [
      'found_data',
      'statuses',
      'positions',
      'divisions',
      'departments',
      'shifts',
      'employees',
      'provinces',
      'districts',
      'communes',
      'villages',
      'id_types',
      'spouse_occupations'
    ])
  },
  methods: {
    ...mapActions('employee', [
      'getDistrict',
      'getCommune',
      'getVillage',
      'getDepartment'
    ]),

    fetchResourceBeforeCreate() {
      this.ready_fetch = true
      this.$store
        .dispatch('employee/dataBeforeCreate')
        .then(() => {
          this.ready_fetch = false
          this.setEditData()
        })
        .catch(error => {
          this.ready_fetch = false
          this.$toasted.error(error.message)
        })
    },

    getImployeeId() {
      this.$store
        .dispatch('employee/getImployeeId', this.model.hired_date)
        .then(response => {
          this.model.emp_id = response[0].employee_id
        })
    },
    async update() {
      this.errors = new Errors()
      this.waiting = true
      if (
        this.model.photo instanceof File ||
        this.model.photo instanceof Blob
      ) {
        new Compressor(this.model.photo, {
          quality: 0.2,
          success: async result => {
            let formData = new FormData()
            formData.append('photo', result)
            let photo_path = await this.$store.dispatch(
              'employee/uploadPhoto',
              formData
            )

            await this.$store
              .dispatch(
                'employee/update',
                Object.assign({}, this.model, {
                  photo: photo_path
                })
              )
              .then(response => {
                this.waiting = false
                this.$toasted.success(response.message)
                this.$router.push({ name: 'employee' })
              })
              .catch(error => {
                this.waiting = false
                this.errors = new Errors(error.errors)
                this.$toasted.error(error.message)
              })
          }
        })
      } else {
        this.$store
          .dispatch(
            'employee/update',
            Object.assign({}, this.model, {
              photo: this.model.photo
            })
          )
          .then(response => {
            this.waiting = false
            this.$toasted.success(response.message)
            this.$router.push({ name: 'employee' })
          })
          .catch(error => {
            this.waiting = false
            this.errors = new Errors(error.errors)
            this.$toasted.error(error.message)
          })
      }
    },

    setEditData() {
      if (this.found_data === null) return

      this.model = Object.assign({}, this.found_data)
      this.getReceiverList(this.found_data)
    },

    getReceiverList(value) {
      this.model.notification_receiver = []
      if (!value.notification_receiver) {
        return []
      }
      let empId = value.notification_receiver.split(',')
      empId.map(el => {
        let employee = this.employees.filter(em => em.staff_id == el)
        this.model.notification_receiver.push(employee[0].staff_id)
      })
    }
  },
  watch: {
    'model.status': function(value) {
      if (value == 'Active') {
        this.required = false
        this.model.status_effective_date = ''
      } else {
        this.required = true
      }
    },
    'model.division_id': function(value) {
      if (value) {
        this.getDepartment(value)
      }
    },
    'model.province_code': function(value) {
      if (value) {
        this.getDistrict(value)
      }
    },
    'model.district_code': function(value) {
      if (value) {
        this.getCommune(value)
      }
    },
    'model.commune_code': function(value) {
      if (value) {
        this.getVillage(value)
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('employee/RESET_STATE')
      this.$store.commit('employee/SET_FOUND_DATA', {})
    }
    next()
  }
}
</script>
<style lang="scss" scoped>
.employee-image-input {
  background: #fff;
  border-radius: 5px;
  padding: 3px;
  -webkit-box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
</style>
